<template>

  <!-- <Toast :group="page.name" position="bottom-center" /> -->
  <Loader v-if="loader" />

  <div class="page">
      <div class="formgrid grid">
        <div class="field col-12 md:col-3">
          <Calendar class="w-full" v-model="period" dateFormat="dd-mm-yy" selectionMode="range" placeholder="Periodo" :showIcon="true" />
          <div v-show="validationErrors.period && submitted" class="p-error">Campo richiesto.</div>
        </div>
        <div class="field col-12 md:col-3">
          <MultiSelect v-model="agentsToExclude" :options="agents" optionLabel="name" optionValue="id" dataKey="id" :filter="true" placeholder="Agenti da escludere" class="w-full" />
        </div>
        <div class="field col-12 md:col-3">
          <MultiSelect v-model="agentsToApart" :options="agents" optionLabel="name" optionValue="id" dataKey="id" :filter="true" placeholder="Agenti da distinguere" class="w-full" />
        </div>
        <div class="field col-12 md:col-3 flex align-items-start">
          <Button @click="downloadExportDAR" class="w-full" label="Scarica export" />
        </div>
      </div>
    

  </div>

</template>

<script>

import moment from 'moment'
import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import UtilityService from '@/services/ask-management/utility-service'
import Loader from '@/components/Loader.vue'


export default {
  components: {
    Loader
  },
    
  setup() {
    const loader = ref(false)

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const agents = ref()
    const agentsToExclude = ref([])
    const agentsToApart = ref([])
    const period = ref()
    const validationErrors = ref({})
    const submitted = ref(true)
    
      
    onMounted(() =>{
      getAgenti()
    })

    const getAgenti = () => {
      loader.value = true
      utilityService.getAgenti()
      .then((res) =>{
        agents.value = res.items
      })
      .finally(()=>{
        loader.value = false
      })
    }

    const downloadExportDAR = () => {
      if (validateForm()) {
        loader.value = true
        let dates = [];
        if (period.value[0]) {
          dates[0] = moment(period.value[0]).format('YYYY-MM-DD');
          dates[1] = moment(period.value[0]).format('YYYY-MM-DD');
        }
        if (period.value[1]) {
          dates[1] = moment(period.value[1]).format('YYYY-MM-DD');
        }
        
        service.downloadExportDAR(dates, agentsToExclude.value, agentsToApart.value)
        .finally(()=>{
          loader.value = false
        })
      }
    }

    const validateForm = () => {

      if (!period.value) {
          validationErrors.value['period'] = true;
      } else {
        delete validationErrors.value['period'];
      }

      return !Object.keys(validationErrors.value).length;
    }

    

    return {
      loader,
      period,
      agents,
      agentsToExclude,
      agentsToApart,
      downloadExportDAR,
      validationErrors,
      submitted,
      
    }
  }
}


</script>


<style scoped>
.wrap {
  padding: 10px;
  border: 1px solid rgba(51, 51, 51, 0.064);
}
</style>
